export default {
  pageTitle: "Aiuto e supporto",
  pageDescription: "Trova risposte o invia una richiesta di supporto",
  myTickets: "I miei ticket",
  sections: {
    faqTitle: "Domande frequenti",
    faqDescription: "Consulta le risposte alle domande più comuni",
    ticketTitle: "Invia un ticket di supporto",
    ticketDescription:
      "Descrivi il tuo problema e il nostro team ti risponderà via email",
  },
  needHelp: {
    title: "Non hai trovato quello che cercavi?",
    description:
      "Il nostro team di supporto è a disposizione. Invia un ticket e ti risponderemo il prima possibile.",
    action: "Invia un ticket",
  },
  tabs: {
    faq: "FAQ",
    faqDesc: "Risposte alle domande più comuni",
    ticket: "Invia ticket",
    ticketDesc: "Segnala problemi o chiedi assistenza",
  },
  faqSearchPlaceholder: "Cerca tra domande e risposte",
  faqAll: "Tutte",
  faqNone: "Nessuna FAQ trovata per questa categoria",
  ticketForm: {
    requestTypeLabel: "Che tipo di richiesta è?",
    requestTypeHint: "Seleziona l'opzione che descrive meglio la tua richiesta",
    priorityLabel: "Priorità",
    priorityHint: "Quanto è urgente questo problema per la tua attività?",
    subjectLabel: "Oggetto",
    subjectPlaceholder: "Breve descrizione del problema",
    messageLabel: "Messaggio",
    messagePlaceholder: "Descrivi il problema in dettaglio...",
    attachmentsLabel: "Allegati",
    attachmentsHint:
      "Trascina i file qui o clicca per caricarli (max 20 MB ciascuno)",
    addFiles: "Aggiungi file",
    submit: "Invia ticket",
    fileTooLarge: "{{name}} è troppo grande. Dimensione massima {{max}}.",
    fileUnsupported: "{{name}} non è un tipo di file supportato.",
    toastSelectCategory: "Seleziona una categoria",
    toastEnterSubject: "Inserisci un oggetto",
    toastEnterMessage: "Inserisci un messaggio",
    toastSubmitted: "Ticket inviato! Ti risponderemo presto.",
    toastSubmitFailed: "Impossibile inviare il ticket. Riprova.",
    toastAttachmentsFailed:
      "Ticket creato, ma non è stato possibile caricare gli allegati. Puoi aggiungerli dalla pagina del ticket.",
    categories: {
      problem: "Problema",
      suggestion: "Suggerimento",
      improvement: "Miglioramento",
      question: "Domanda",
      billing: "Fatturazione",
    },
    priorities: {
      critical: "Critica",
      high: "Alta",
      medium: "Media",
      normal: "Normale",
      low: "Bassa",
    },
    respondLine: "Risponderemo a {{email}}",
  },
  list: {
    title: "I miei ticket",
    description: "Visualizza e gestisci le tue richieste di supporto",
    backToSupport: "Aiuto e supporto",
    newTicket: "Nuovo ticket",
    createTicket: "Crea ticket",
    searchPlaceholder: "Cerca ticket per oggetto o numero...",
    loadingTickets: "Caricamento ticket...",
    loadError: "Impossibile caricare i ticket",
    noTicketsFound: "Nessun ticket trovato",
    tryAdjusting: "Prova a modificare la ricerca o il filtro",
    createFirstHint: "Crea il tuo primo ticket per ricevere aiuto",
    lastActivityShort: "Ultima: {{when}}",
    replyNeeded: "Risposta richiesta",
    messageCountPlain: "{{count}}",
    stats: {
      ongoing: "Attivi",
      filterLabel: "Stato ticket",
      total: "Tutti",
    },
  },
  adminList: {
    searchPlaceholder: "Cerca per numero ticket, oggetto o venditore...",
    filterAny: "Qualsiasi",
    priority: "Priorità",
    category: "Categoria",
    ticketsFound_one: "{{count}} ticket trovato",
    ticketsFound_other: "{{count}} ticket trovati",
    loadingTickets: "Caricamento ticket...",
    noTicketsFound: "Nessun ticket trovato",
    tryAdjusting: "Prova a modificare i filtri",
    allCaughtUp: "Tutto in regola!",
    clearFilters: "Cancella filtri",
  },
  sidebar: {
    seller: "Venditore",
    unknownSeller: "Venditore sconosciuto",
    sendEmail: "Invia email",
    openProfile: "Apri profilo",
    statusAndPriority: "Stato e priorità",
    status: "Stato",
    priority: "Priorità",
    details: "Dettagli",
    category: "Categoria",
    created: "Creato",
    lastUpdated: "Ultimo aggiornamento",
    resolved: "Risolto",
    messages: "Messaggi",
    messagesTotal: "{{count}} in totale",
    quickActions: "Azioni rapide",
    markAsResolved: "Segna come risolto",
    closeTicket: "Chiudi ticket",
    reopenTicket: "Riapri ticket",
  },
  adminDetail: {
    loadingTicket: "Caricamento ticket...",
    notFound: "Ticket non trovato",
    backToTickets: "Torna ai ticket",
    ticketDetails: "Dettagli ticket",
    openedOn: "Aperto il {{date}}",
    messagesCount: "{{count}} messaggi",
    replyPlaceholder:
      "Scrivi la tua risposta (verrà inviata un'email al venditore)...",
    ticketClosed: "Questo ticket è chiuso.",
    reopenTicket: "Riapri ticket",
  },
  messageInput: {
    modeLabel: "Tipo di messaggio",
    defaultPlaceholder: "Scrivi il tuo messaggio...",
    internalNotePlaceholder: "Aggiungi una nota interna...",
    replyToPartner: "Rispondi al venditore",
    internalNote: "Nota interna",
    internalNoteWarning: "Le note interne sono visibili solo allo staff",
    attach: "Allega",
    fileTooLarge: "{{name}} è troppo grande. Dimensione massima {{max}}.",
    fileUnsupported: "{{name}} non è un tipo di file supportato.",
    addNote: "Aggiungi nota",
    send: "Invia",
  },
  messageBubble: {
    internalNote: "Nota interna",
    supportTeam: "Team di supporto",
    you: "Tu",
    sellerFallback: "Venditore",
  },
  detail: {
    messageSent: "Messaggio inviato!",
    sendMessageError: "Impossibile inviare il messaggio",
    loadingTicket: "Caricamento ticket...",
    notFound: "Ticket non trovato",
    backToTickets: "Torna ai ticket",
    conversationEmpty:
      "Ancora nessun messaggio. Inizia la conversazione qui sotto.",
    messagesCount_one: "{{count}} messaggio",
    messagesCount_other: "{{count}} messaggi",
    messagePlaceholder: "Scrivi il tuo messaggio...",
    resolvedTitle: "Questo ticket è stato risolto",
    resolvedNeedHelp: "Serve altro aiuto?",
    openNewTicket: "Apri un nuovo ticket",
    openedOn: "Aperto il {{date}}",
    replyNeededTitle: "Il team di supporto ha risposto",
    replyNeededDescription:
      "Leggi l'ultimo messaggio qui sotto e invia la tua risposta per tenere aperto il ticket.",
  },
  adminHub: {
    ticketsTab: "Ticket di supporto",
    ticketsDescription: "Gestisci ticket di supporto partner",
    chatsTab: "Chat supporto clienti",
    chatsDescription: "Gestisci chat di supporto clienti",
  },
  customerSupportChats: {
    searchPlaceholder: "Cerca per contatto…",
    loading: "Caricamento chat…",
    loadingChat: "Caricamento conversazione…",
    empty: "Nessuna chat di supporto corrisponde a questo filtro",
    emptyOpen: "Nessuna chat di supporto aperta",
    statusFilter: "Stato",
    filterOpen: "Aperte",
    filterClosed: "Chiuse",
    filterAll: "Tutte",
    closedBadge: "Chiusa",
    selectChat: "Seleziona una chat per vedere la conversazione",
    noMessages: "Nessun messaggio",
    guest: "Ospite",
    registeredCustomer: "Cliente registrato",
    replyPlaceholder: "Rispondi al cliente…",
    chatClosed: "Questa chat è chiusa.",
    closeChat: "Chiudi chat",
    closed: "Chat chiusa",
    recentBookings: "Prenotazioni recenti",
    noBookings: "Nessuna prenotazione per questo contatto",
    lastHandshakeBadge: "Ultimo handshake",
    openBooking: "Apri",
    amend: "Modifica",
    reopenHandshake: "Riapri handshake",
    cancelBooking: "Annulla",
    amendTitle: "Modifica data/ora prenotazione",
    visitDateLabel: "Data visita",
    visitTimeLabel: "Orario visita",
    overrideCapacity: "Ignora avvisi capacità/scadenza",
    amendConfirm: "Salva modifica",
    amendSuccess: "Prenotazione modificata",
    cancelTitle: "Annulla prenotazione",
    cancelDescriptionWithDetails:
      "Cancel the booking for {{name}} ({{activity}})? Confirm amount on the booking detail if needed. Refunds start automatically and cannot be undone.",
    refundChoiceLabel: "Policy di rimborso",
    refundDefault: "Rimborso in finestra, altrimenti no rimborso",
    refundForce: "Rimborso sempre",
    refundNone: "Mai rimborso (regola come evasa se pagata)",
    cancelConfirm: "Conferma annullamento",
    cancelSuccess: "Prenotazione annullata",
    reopenSuccess: "Handshake riaperto; questa chat è stata chiusa",
    reopenConfirmTitle: "Riaprire l'handshake?",
    reopenConfirmMessage:
      "Chiuderà la chat di supporto e riaprirà l'handshake così il partner può modificare la prenotazione in chat.",
    reopenConfirm: "Riapri handshake",
    cancelForceConfirmTitle: "Confermare l'annullamento con override?",
    cancelForceRefundMessage:
      "Hai scelto il rimborso sempre. Questo ignora la policy della finestra di rimborso e non è annullabile da questa schermata.",
    cancelForceNoneMessage:
      "Hai scelto di non rimborsare mai. Le prenotazioni pagate possono essere regolate come evase senza rimborso al cliente.",
  },
} as const;
